<template>
  <div class="header-wrapper row m-0">
    <SearchBar />
    <Logo />
    <div class="left-header col horizontal-wrapper pl-0">
      <ul class="horizontal-menu d-flex">
        <li class="mr-2" v-if="getCompanyName() != ''">
          <span class="cut-text">{{ getCompanyName() }}</span>
        </li>
        <li class="d-block">
          <i class="fa fa-map-marker m-r-5"></i>
          <span></span>
        </li>
      </ul>


    </div>
    <div class="nav-right col-4 pull-right right-header p-0">
      <ul class="nav-menus">
        <li class="language-nav">
          <Language />
        </li>
        <Cart v-if="false"></Cart>
        <!-- <Notifications /> -->
        <Profile />
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Bookmark from '../bookmark';
import BonusUI from './bonusUI';
import LevelMenu from './levelMenu';
import Language from './language';
import Notifications from './notifications';
import Mode from './mode';
import Cart from './cart';
import Message from './message';
import Maximize from './maximize';
import Profile from './profile';
import Logo from './logo';
import SearchBar from './search';
import { productService } from '@/_services/product.service';

export default {
  name: 'Search',
  components: {
    Bookmark,
    BonusUI,
    LevelMenu,
    Language,
    Notifications,
    Mode,
    Cart,
    Message,
    Maximize,
    Profile,
    Logo,
    SearchBar,
  },
  data() {
    return {
      bookmark: false,
      companyName: '',
         };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.searchData,
      megamenuItems: (state) => state.menu.megamenu,
      searchOpen: (state) => state.menu.searchOpen,
      paymentItemList: (state) => state.paymentItem.paymentItemList
    }),
    user() {
      return this.$store.state.authentication.user
    }
  },
  created(){
    //this.initPaymentItem();
  },
  methods: {
    search_open() {
      this.$store.state.menu.searchOpen = true;
    },
    bookmark_open() {
      this.bookmark = !this.bookmark;
    },
    getCompanyName(){
      var currentLangId = localStorage.getItem('currentLangId');
      return currentLangId == "950" ? this.user.companyNameTc : currentLangId == "936" ? this.user.companyNameSc : currentLangId == "1252" ? this.user.companyNameEn : ""
    },
    initPaymentItem() {
      //Init paymentItem with bought item
      var that = this;
      productService.getSysAccountPaymentInfo({ CompanyId: this.user.empCompanyId, demodate: '' }).then((res) => {
        if (res.isSuccessful) {
          if (res.data != null) {
            let data = res.data;
            if (data.length > 0) {
              data.forEach(element => {
                that.paymentItemList.forEach(item => {
                  if(item.rid == element.rid){
                    item.stockPerAccount = element.totalQty - element.payTotalQty;
                  }
                })
              });
            }
          }

        }
      });
    },
  },
};
</script>
